import r, { useEffect as m } from "react";
import { useTranslation as d } from "react-i18next";
import { useServiceSessionFromForm as u } from "../../../hooks/backend/useServiceSession.js";
import p from "../../../hooks/customization/useCustomization.js";
import { useOrdering as f } from "../context.js";
import l from "./steps.module.scss.js";
function T() {
  const { t: o } = d(), {
    currentStep: t,
    form: n
  } = f(), {
    getTextTranslations: a
  } = p(), e = a("popup"), { getRestaurantUrl: c } = u(), s = async () => {
    const i = await c(
      n,
      t.data.restaurant,
      t.data.service,
      t.data.now
    );
    i && (window.location.href = i);
  };
  return m(() => {
    s();
  }, []), /* @__PURE__ */ r.createElement("div", { "data-testid": "restaurant-redirection-step" }, /* @__PURE__ */ r.createElement("div", { className: l.formTitle }, (e == null ? void 0 : e.redirection_title) || o("shopLanding.redirection.title")), /* @__PURE__ */ r.createElement("div", null, (e == null ? void 0 : e.redirection) || o("shopLanding.redirection")));
}
export {
  T as RestaurantRedirectionStep
};
//# sourceMappingURL=RestaurantRedirectionStep.js.map
